<template>
  <v-layout wrap v-if="content">
    <v-flex xs12 style="padding: 10px">
      <select-image 
        :image="content.IconsURL"
        :onChange="handleChangeImage"
        :locale="locale"
        :imageWidth="200"
        :imageHeight="200"
        :aspectRatio="1/1"
        :folder="workspaceID"
      />
    </v-flex>
    <v-flex xs12 style="padding: 10px">
      <v-btn-toggle v-model="content.IconsAlign" @change="handleChangeIsModified">
        <v-btn value="left">
          <v-icon>mdi-format-align-left</v-icon>
        </v-btn>

        <v-btn value="center">
          <v-icon>mdi-format-align-center</v-icon>
        </v-btn>

        <v-btn value="right">
          <v-icon>mdi-format-align-right</v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'
import utils from '@/services/utils'
import SelectImage from '@/components/selectImage/Index'
export default {
  name: 'Form43Icons',
  components: {
    SelectImage,
  },
  props: {
    editedItem: {
      type: Object,
      required: true
    },
    onChangeIsModified: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    content: null,
  }),
  computed: {        
    ...mapState('app', ['locale', ]),
    workspaceID () {
      return utils.getWorkspace('dtouch')
    },
  },
  watch: {
    editedItem () {
      this.prepareContent()
    },
  },
  mounted () {
    this.prepareContent()
  },
  methods: {
    prepareContent () {
      this.content = this.editedItem
    },
    handleChangeImage (v) {
      if (v) {
        this.content.IconsURL = v.base64
        this.content.newImage = v
        this.handleChangeIsModified()
      }
    },
    handleChangeIsModified () {
      this.onChangeIsModified(this.content) 
    },
  },
}
</script>

